import React, { useEffect, useState } from 'react'
import * as AnalyticsActions from '../../redux/analytics/actions'
import ProFunnelTable from '../../components/ProFunnelTable'
import { useDispatch, useSelector } from 'react-redux';
import { fetchTopProLinksRequested } from '../../store/analytics/actions';

function ProFunnelPage () {
  const dispatch = useDispatch()
  const {
    events: funnel,
    error
  } = useSelector(state => state.analytics);

  useEffect(() => {
    dispatch(fetchTopProLinksRequested())
  }, [])
  const columns = [
    {
      title: 'Событие',
      field: 'name',
      sortable: true,
    },
    {
      title: 'Пользователи до 7 дней',
      field: 'count7',
      sortable: true,
      right: true,
    },
    {
      title: 'Пользователи до 30 дней',
      field: 'count30',
      sortable: true,
      right: true,
    },
    {
      title: 'Пользователи до 90 дней',
      field: 'count90',
      sortable: true,
      right: true,
    },
  ]
  return (
    <div  style={{ width: '100%' }}>
      {
        error &&
        <div className="form-group">
          <div className="alert alert-danger">
            <strong>Ошибка!</strong> {error}
          </div>
        </div>
      }
      <div>
        <h3>Воронка профи</h3>
      </div>
      <ProFunnelTable columns={columns} data={funnel}/>
    </div>
  )
}

export default ProFunnelPage



// WEBPACK FOOTER //
// ./src/pages/ProFunnelPage/index.jsx